<template>
  <b-sidebar
    v-model="toggle"
    width="80%"
    id="sidebar-right"
    title="Product Catalog"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template #default="{ hide }">
      <div
        class="d-flex text-light align-items-center px-3 py-2"
        style="background-color:#495057;"
      >
        <strong class="mr-auto">{{ mode }}</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <div class="px-3 py-2">
        <div class="row">
          <div class="col-12">
            <div class="card" v-if="mode === 'Add Product in Catalog' || mode === 'Delete Product in Catalog'">
              <add-delete-product-import-excel-catalog-product 
                :model="model" 
                :mode="mode" 
                :catalogIdSelected="catalogIdSelected"
                :defaultListProductItems="listProductItems"
                @onSave="onSaveAddOrDeleteImportExcelProduct"/>
            </div>
            <div class="card" v-if="mode === 'Add Product'">
              <add-product-catalog-product
                :model="model" 
                :mode="mode" 
                :catalogIdSelected="catalogIdSelected"
                :listProductItems="listProductItems"
                @onSave="onSaveAddProduct"/>
            </div>
            <div class="card" v-if="mode === 'Delete All'">
              <add-product-all-catalog-product
                :catalogIdSelected="catalogIdSelected"
                @onSave="onDeleteAll"/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import productService from '@/helpers/service/product-service'
import catalogService from '@/helpers/service/catalog-service'
import XLSX from 'xlsx'
import AddDeleteProductImportExcelCatalogProduct from '@/components/product-catalog/add-delete-product-import-excel-catalog-product'
import AddProductCatalogProduct from '@/components/product-catalog/add-product-catalog-product'
import DeleteProductAllCatalogProduct from '@/components/product-catalog/delete-product-all-catalog-product'

export default {
  components: {
    'add-delete-product-import-excel-catalog-product': AddDeleteProductImportExcelCatalogProduct,
    'add-product-catalog-product': AddProductCatalogProduct,
    'add-product-all-catalog-product': DeleteProductAllCatalogProduct
  },
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: '',
    },
    catalogIdSelected: {
      type: String,
      default: '',
    },
    listProductItems: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pages: null,
      remark: null,
      productId: '',
      typeId: '',
      typeName: '',
      catalogId: '',
      catalogName: '',
      reloadCatalogType: false,
      reloadCatalog: false,
      file: null,
      // fileName: '',
      exportData: [
        {
          'รหัสสินค้า (OFM)': '',
          เลขหน้า: '',
          หมายเหตุเพิ่มเติม: '',
        },
      ],
      toggle: false,
      filter: {
        name: '',
      },
      searchProductCatalog: null,
      firstRowOnPage: 1,
      pageSize: 999999,
      pageNo: 1,
      productItems: [],
      tempProductItems: [],
      productcatalogTablefields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'pages',
          label: 'เลขหน้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
        },
        {
          key: 'remark',
          label: 'หมายเหตุเพิ่มเติม',
          tdClass: 'text-center',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      isLoading: false,
    }
  },
  computed: {},
  watch: {
    toggleSideBar: function(value) {
      this.toggle = value
      // if (value) {
      //   this.onClear()
      // }
    },
    productItems: {
      handler: function(val) {
        val.forEach(element => {
          if (element.is_error) {
            element._rowVariant = 'danger'
          } else {
            element._rowVariant = ''
          }
        })
      },
      deep: true,
    },
    pages: function(value) {
      // if (this.productItems.length > 0) {
      //   if (value === '' || value === null || value === undefined) {
      //     this.productItems.forEach((element, index) => {
      //       element.pages =
      //         this.tempProductItems[index].pages === undefined
      //           ? null
      //           : this.tempProductItems[index].pages
      //     })
      //   } else {
      //     this.productItems.forEach(element => {
      //       if (element.inventory_status !== 'Delete') {
      //         element.pages = value
      //       }
      //     })
      //   }
      // }
      if (this.productItems.length > 0) {
        this.productItems.forEach(element => {
          if (element.inventory_status !== 'Delete') {
            element.pages = value
          }
        })
      }
    },
    remark: function(value) {
      // if (this.productItems.length > 0) {
      //   if (value === '' || value === null || value === undefined) {
      //     this.productItems.forEach((element, index) => {
      //       element.remark =
      //         this.tempProductItems[index].remark === undefined
      //           ? null
      //           : this.tempProductItems[index].remark
      //     })
      //   } else {
      //     this.productItems.forEach(element => {
      //       if (element.inventory_status !== 'Delete') {
      //         element.remark = value
      //       }
      //     })
      //   }
      // }
      if (this.productItems.length > 0) {
        this.productItems.forEach(element => {
          if (element.inventory_status !== 'Delete') {
            element.remark = value
          }
        })
      }
    },
  },
  mounted: function() {},
  methods: {
    async onFilter() {
      if (this.filter.name) {
        this.productItems = []
        this.tempProductItems = []
        this.pages = null
        this.remark = null
        let params = new URLSearchParams()
        params.append('pageNo', 1)
        params.append('pageSize', 9999)
        params.append('sort', 'product_id')
        params.append('product_id_or_sku_code_ofm', this.filter.name.trim())
        let result = await productService.getProductSkuListAsync(params)
        if (result.status === 200 || result.status === 201) {
          if (result.data.items && result.data.items.length === 0) {
            this.$utils.notification('warning', 'ไม่พบรหัสสินค้าในระบบ', 2000)
          } else {
            result.data.items.forEach(element => {
              var displayName = element.product_names.find(
                f => f.type === 'Online'
              ).display_name
              var tempItem = {
                id: element.id,
                product_id: element.product_id,
                sku_code_ofm: element.id,
                product_display_name: {
                  th: displayName.th,
                  en: displayName.en,
                },
                inventory_status: element.product_status.inventory,
                sale_status: element.product_status.sale,
                pages: null,
                remark: null,
                error_message: element.error_message,
                is_error: element.is_error,
              }

              // var tempProduct = {
              //   id: element.id,
              //   pages: null,
              //   remark: null,
              //   is_error: element.is_error,
              // }
              this.productItems.push(tempItem)
              // this.tempProductItems.push(tempProduct)
            })

            this.productId = result.data.items
              ? result.data.items[0].product_id
              : ''
          }
        } else if (result.status === 404) {
          this.$utils.notification('error', 'ไม่พบรหัสสินค้าในระบบ', 2000)
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      }
    },
    async onUpload(value) {
      this.productItems = []
      this.tempProductItems = []
      this.pages = null
      this.remark = null
      let listSkuCodeOFM = []
      value.forEach(element => {
        listSkuCodeOFM.push(element.sku_code_ofm)
      })
      let objModel = {
        sku_code_ofms: listSkuCodeOFM,
      }
      let result = await productService.searchProductSkuIncludeProductAsync(
        objModel
      )
      console.log('value', value)
      if (result.status === 200 || result.status === 201) {
        result.data.forEach(element => {
          var tempItem = {}
          var tempProduct = {}
          if (element.is_error) {
            tempItem = {
              id: null,
              product_id: null,
              sku_code_ofm: element.id,
              product_display_name: {
                th: null,
                en: null,
              },
              inventory_status: null,
              sale_status: null,
              pages: 0,
              remark: null,
              error_message: element.error_message,
              is_error: element.is_error,
            }
            tempProduct = {
              id: null,
              pages: 0,
              remark: null,
              is_error: element.is_error,
            }
          } else {
            var displayName = element.product_names.find(
              f => f.type === 'Online'
            ).display_name
            tempItem = {
              id: element.id,
              product_id: element.product_id,
              sku_code_ofm: element.id,
              product_display_name: {
                th: displayName.th,
                en: displayName.en,
              },
              inventory_status: element.product_status.inventory,
              sale_status: element.product_status.sale,
              pages: value.find(f => f.sku_code_ofm === element.id).pages,
              remark: value.find(f => f.sku_code_ofm === element.id).remark,
              error_message: element.error_message,
              is_error: element.is_error,
            }
            // tempProduct = {
            //   id: element.id,
            //   pages: value.find(f => f.sku_code_ofm === element.id).pages,
            //   remark: value.find(f => f.sku_code_ofm === element.id).remark,
            //   is_error: element.is_error,
            // }
          }
          this.productItems.push(tempItem)
          // this.tempProductItems.push(tempProduct)
        })
      } else if (result.status === 404) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
          2000
        )
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onSaveAddOrDeleteImportExcelProduct(productItems) {
      this.$emit('hidden')
      this.$emit('getDataSideBar', productItems)
      this.onClear()
    },
    async onSaveAddProduct(productItems) {
      this.$emit('hidden')
      this.$emit('getDataSideBar', productItems)
      this.onClear()
    },
    async onSave() {
      if (this.productItems.length === 0) {
        this.$utils.notification(
          'error',
          this.mode === 'Delete Product in Catalog' ? 'ไม่มีรายการสินค้าให้ลบ' : 'ไม่มีรายการสินค้าให้ Add เพิ่ม',
          2000
        )
      } else if (this.productItems.some(s => s.is_error == true)) {
        this.$utils.notification(
          'error',
          'ไม่สามารถดำเนินการต่อได้เนื่องจากชุดยังมูลยังมีรายการที่ผิดพลาด',
          2000
        )
      } else {
        if (
          this.productItems.find(p => p.inventory_status === 'Delete') !==
          undefined
        ) {
          this.$utils.notification(
            'error',
            'มีสินค้าสถานะ Delete อยู่ในรายการ ไม่สามารถดำเนินการต่อได้',
            2000
          )
        } else {
          let checkExist = false
          if (this.listProductItems.length > 0) {
            this.productItems.forEach(element => {
              if (
                this.listProductItems.find(p => p.id === element.id) !==
                undefined
              ) {
                checkExist = true
              }
            })
            if (checkExist) {
              await this.$utils
                .confirmAlertDisplay(
                  `มีข้อมูลสินค้านี้อยู่ใน Catalog แล้ว ต้องการแก้ไขข้อมูลใหม่ใช่หรือไม่`,
                  ''
                )
                .then(result => {
                  if (result) {
                    this.$emit('hidden')
                    this.$emit('getDataSideBar', this.productItems)
                    this.onClear()
                  }
                })
            } else {
              this.$emit('hidden')
              this.$emit('getDataSideBar', this.productItems)
              this.onClear()
            }
          } else {
            this.$emit('hidden')
            this.$emit('getDataSideBar', this.productItems)
            this.onClear()
          }
        }
      }
      // else if (this.listProductItems.length > 0) {
      //   await this.$utils
      //     .confirmAlertDisplay(
      //       `มีข้อมูลสินค้านี้อยู่ใน Catalog แล้ว ต้องการแก้ไขข้อมูลใหม่ใช่หรือไม่`,
      //       ''
      //     )
      //     .then(result => {
      //       if (result) {
      //         this.$emit('hidden')
      //         this.$emit('getDataSideBar', this.productItems)
      //       }
      //     })
      // } else {
      //   await this.$emit('hidden')
      //   await this.$emit('getDataSideBar', this.productItems)
      // }
    },
    async onDeleteAll() {
      this.$emit('hidden')
      this.$emit('getDataSideBar')
      this.onClear()
    },
    onClear() {
      this.productId = ''
      this.typeId = ''
      this.typeName = ''
      this.catalogId = ''
      this.catalogName = ''
      this.reloadCatalogType = false
      this.reloadCatalog = false

      // if (this.mode === 'Import Excel') {
      //   if (this.$refs.file !== undefined) {
      //     this.$refs.file.value = ''
      //   }
      // }
      this.file = null
      // this.fileName = ''
      this.filter = {
        name: '',
      }
      this.searchProductCatalog = null
      this.productItems = []
      this.tempProductItems = []
      this.pages = null
      this.remark = null

      this.$nextTick(() => {
        this.reloadCatalogType = true
        this.reloadCatalog = true
      })
    },
    onClearProduct() {
      this.productItems = []
      this.tempProductItems = []
      this.productId = ''
      this.pages = null
      this.remark = null
    },
    async getDetail(id) {
      try {
        this.isLoading = true
        let params = new URLSearchParams()
        params.append('pageSize', 999999)
        params.append('sort', 'product_id')
        let result = await catalogService.GetCatalogProductsByIdAsync(
          id,
          params
        )
        this.productItems = []
        this.tempProductItems = []
        this.pages = null
        this.remark = null
        if (result.status === 200) {
          if (result.data.items && result.data.items.length > 0) {
            result.data.items.forEach(element => {
              element.skus.forEach(element2 => {
                var displayName = element2.product_names.find(
                  f => f.type === 'Online'
                )
                var tempItem = {
                  id: element2.sku_id,
                  product_id: element.product_id,
                  sku_code_ofm: element2.sku_id,
                  product_display_name: {
                    th: displayName ? displayName.display_name.th : '',
                    en: displayName ? displayName.display_name.en : '',
                  },
                  inventory_status: element2.product_status.inventory,
                  sale_status: element2.product_status.sale,
                  pages:
                    element2.pages && element2.pages.length > 0
                      ? element2.pages[0]
                      : [0],
                  remark: element2.remark,
                  error_message: '',
                  is_error: false,
                }
                this.productItems.push(tempItem)
              })
            })
          }
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        console.log('Error : ', err)
      }
    },
    async onClone(value) {
      let listSkuId = []
      value.forEach(element => {
        listSkuId.push(element.sku_id)
      })
      let objModel = {
        sku_id: listSkuId,
      }
      let result = await productService.searchProductSkuIncludeProductAsync(
        objModel
      )
      if (result.status === 200 || result.status === 201) {
        result.data.forEach(element => {
          var displayName = element.product_names.find(f => f.type === 'Online')
            .display_name
          var tempItem = {
            id: element.id,
            product_id: element.product_id,
            sku_code_ofm: element.id,
            product_display_name: {
              th: displayName.th,
              en: displayName.en,
            },
            inventory_status: element.product_status.inventory,
            sale_status: element.product_status.sale,
            pages: value.find(f => f.sku_id === element.id).pages,
            remark: value.find(f => f.sku_id === element.id).remark,
            error_message: element.error_message,
            is_error: element.is_error,
          }
          // var tempProduct = {
          //   id: element.id,
          //   pages: value.find(f => f.sku_id === element.id).pages,
          //   remark: value.find(f => f.sku_id === element.id).remark,
          //   is_error: element.is_error,
          // }
          this.productItems.push(tempItem)
          // this.tempProductItems.push(tempProduct)
        })
      } else if (result.status === 404) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
          2000
        )
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onCatalogTypeSelector(data) {
      //   this.reloadCatalogType = false
      this.reloadCatalog = true
      this.typeId = data.value
      this.typeName = data.text
      this.catalogId = null
      this.catalogName = null
    },
    async onCatalogSelector(data) {
      this.reloadCatalog = false
      this.catalogId = data.value
      this.catalogName = data.text
      await this.getDetail(this.catalogId)
    },
    onDeleteProductCatalog(id) {
      this.productItems.splice(
        this.productItems.findIndex(element => element.id === id),
        1
      )

      // this.tempProductItems.splice(
      //   this.tempProductItems.findIndex(element => element.id === id),
      //   1
      // )
    },
    onDownloadTemplate() {
      const dataWS = XLSX.utils.json_to_sheet(this.exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'TemplateProductCatalog.xlsx')
    },
    async importExcel(e) {
      var vm = this
      var selectedFile = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function(event) {
        var items = []
        var data = event.target.result
        var workbook = XLSX.read(data, {
          type: 'binary',
        })
        workbook.SheetNames.forEach(function(sheetName) {
          var row = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName]
          )

          var headers = ['รหัสสินค้า (OFM)', 'เลขหน้า', 'หมายเหตุเพิ่มเติม']
          var j = 0
          for (var key in row[0]) {
            if (
              key !== headers[j] &&
              key !== null &&
              key !== undefined &&
              key !== ''
            ) {
              // vm.fileName = ''
              vm.items = []
              // vm.Response('500', 'Format ของ File Excel ผิดรูปแบบ', '', 'Error')
              vm.$utils.notification(
                'error',
                'Format ของ File Excel ผิดรูปแบบ',
                2000
              )
              return
            }
            j++
          }
          for (var i = 0; i < row.length; i++) {
            if (
              !(
                (row[i]['รหัสสินค้า (OFM)'] === '' ||
                  row[i]['รหัสสินค้า (OFM)'] === null ||
                  row[i]['รหัสสินค้า (OFM)'] === undefined) &&
                (row[i]['เลขหน้า'] === '' ||
                  row[i]['เลขหน้า'] === null ||
                  row[i]['เลขหน้า'] === undefined) &&
                (row[i]['หมายเหตุเพิ่มเติม'] === '' ||
                  row[i]['หมายเหตุเพิ่มเติม'] === null ||
                  row[i]['หมายเหตุเพิ่มเติม'] === undefined)
              )
            ) {
              items.push({
                sku_code_ofm: String(row[i]['รหัสสินค้า (OFM)']),
                pages: row[i]['เลขหน้า'],
                remark: row[i]['หมายเหตุเพิ่มเติม'],
              })
            }
          }
        })
        vm.onUpload(items)
        // vm.fileName = selectedFile.name
      }
      reader.onerror = function(event) {
        if (event.target.error.name === 'NotReadableError') {
          alert("Canno't read file !")
        }
      }
      reader.readAsBinaryString(selectedFile)
    },
    onClearRowDataError() {
      this.productItems = this.productItems.filter(f => f.is_error == false)
      // this.tempProductItems = this.tempProductItems.filter(
      //   f => f.is_error == false
      // )
    },
    getFile() {
      document.getElementById('file').value = ''
      document.getElementById('file').click()
    },
  },
}
</script>
